@if(documentoOficial$ | async; as documento){
    <div class="w-full bg-white">
    <!-- Header -->
    <div class="flex flex-row  justify-between items-center py-2 px-4 md:px-8 border-b">

        <!-- Title -->
        <div class="w-full flex items-center">
            <arrow-back></arrow-back>
            <div>
                <div class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">Documentos Oficiales</div>
                <div class="ml-0.5 font-medium text-secondary"></div>
            </div>
        </div>
        
    </div>
    <div class="w-full flex flex-col md:flex-row p-4 md:p-8 gap-3 md:gap-8">
        <div class="w-full md:w-4/12 flex flex-auto flex-col">
            <!-- DETALLE -->
            <div class="mt-2 aspect-[9/6]">
                <div
                    class="flex h-full items-center justify-center rounded-lg border bg-gray-50 dark:bg-card"
                >
                    
                    <mat-icon
                        class="text-hint icon-size-24"
                        [svgIcon]="'heroicons_outline:document'"
                    ></mat-icon>
                    
                </div>
            </div>

            <!-- Name & Type -->
            <div class="w-full mt-4 flex flex-col items-start">
                <div
                    class="w-full text-center mt-1 rounded py-2 px-4 text-sm font-semibold leading-5 text-white bg-blue-500">
                        CATEGORIA: {{ documento.tipoDocumentoTexto }}
                </div>
            </div>

            <!-- Information -->
            <div class="mt-4 text-lg font-medium">Información</div>
            <div class="mt-4 flex flex-col divide-y border-b border-t font-medium">
                <div class="flex items-center justify-between py-2">
                    <div class="text-secondary">Elaborado Por</div>
                    <div>{{ documento.generadoPor}}</div>
                </div>
                <div class="flex items-center justify-between py-2">
                    <div class="text-secondary">Fecha de Generación</div>
                    <div>{{ documento.fechaInicioVigencia | date: 'mediumDate'}}</div>
                </div>
                @if(documento.fechaCertificacion){
                    <div class="flex items-center justify-between py-2">
                        <div class="text-secondary">Fecha de Certificación</div>
                        <div>{{ documento.fechaCertificacion | date: 'mediumDate'}}</div>
                    </div>
                }
                <div class="flex items-center justify-between py-2">
                    <div class="text-secondary">Vigencia de Documento</div>
                    <div>{{ documento.mesesVigencia}}</div>
                </div>
               
                <div class="flex items-center justify-between py-2">
                    <div class="text-secondary">Valido hasta</div>
                    <div>{{ documento.fechaFinVigencia | date: 'mediumDate'}}</div>
                </div>

                <div class="flex items-center justify-between py-2">
                    <div class="text-secondary">Sección</div>
                    <div>{{ documento.seccion.descripcion }}</div>
                </div>
                
            </div>
            
            <!-- Actions -->
            <div class="mt-8 flex w-full gap-4">
                <button class="flex-auto" mat-flat-button 
                    [color]="'primary'"
                    (click)="downloadFile(documento)">
                    Descargar
                </button>
                @if(documento.estado.tipologiaId === ID_ESTADO_BORRADOR_DOCUMENTO){
                    <button class="flex-auto" mat-stroked-button
                    (click)="eliminarDocumento(documento)"
                    >Eliminar</button>
                }
            </div>
        </div>

        <div class="w-full md:8/12">
            <span class="text-xl font-bold">Id Interno: {{ documento.documentoGeneradoUuid }} </span>
            <div class="flex items-center gap-3">
                <div
                    class="mt-1 rounded py-1 px-4 text-sm font-semibold leading-5 text-white bg-rose-600">
                        PDF
                </div>
                <div  class="mt-1 rounded py-1 px-4 text-sm font-semibold leading-5 text-white"
                    [ngStyle]="{
                        'background-color': documento.estado.valor1, 
                    }">
                        {{ documento.estado.descripcion }}
                </div>
            </div>
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="mt-8">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Gestiones Vinculadas</span>
                    </ng-template>
                    <ng-template matTabContent>
                        <div class="overflow-x-auto">
                            <elementos-vinculados 
                                [elementosVinculados]="elementosVinculadosDocumentos$ | async"
                                [link]="linkElementoVinculado"
                            ></elementos-vinculados>
                        </div>
                    </ng-template>
                </mat-tab>
                
                <mat-tab label="Actividad">
                    <actividad-reciente [ActividadReciente]="bitacoraDocumento$ | async"></actividad-reciente>              
                </mat-tab>
            </mat-tab-group>
        </div>

    </div>
</div>
}